import { createSlice } from '@reduxjs/toolkit';
import { fetchAccounts, fetchTransactions } from '../thunks/accountThunks';

const initialState = {
  accounts: [],
  transactions: [],
  pagination: {
    limit: 10,
    page: 1,
    pages: 1,
    total: 0
  },
  loading: false,
  error: null
};

const accountsSlice = createSlice({
  name: 'accounts',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch Accounts
      .addCase(fetchAccounts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAccounts.fulfilled, (state, action) => {
        state.loading = false;
        state.accounts = action.payload?.data;
      })
      .addCase(fetchAccounts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch Transactions
      .addCase(fetchTransactions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTransactions.fulfilled, (state, action) => {
        state.loading = false;
        state.transactions = action.payload.data?.transactions;
        state.pagination = action.payload.data?.pagination;
      })
      .addCase(fetchTransactions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export default accountsSlice.reducer; 